// Central API helper. A session token (from password or passkey login) is sent as a
// Bearer header — never in the URL — so credentials don't leak into logs/history.
let TOKEN = null;

export function setToken(t) { TOKEN = t || null; }
export function getToken() { return TOKEN; }

const authHeaders = (extra = {}) => (TOKEN ? { Authorization: `Bearer ${TOKEN}`, ...extra } : { ...extra });

export function apiGet(path) {
  return fetch(path, { headers: authHeaders() });
}

export function apiSend(path, body, method = 'POST') {
  return fetch(path, {
    method,
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
}
